import React from "react";
import { Clock, MapPin, RefreshCw } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const TIME_RANGES = [
  { value: "15m",   label: "Last 15 min" },
  { value: "1h",    label: "Last 1 hour" },
  { value: "6h",    label: "Last 6 hours" },
  { value: "match", label: "Full Match" },
];

export const DashboardFilters = ({
  timeRange,
  onTimeRangeChange,
  zoneId,
  onZoneChange,
  zones = [],
  onRefresh,
  refreshing = false,
}) => {
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="dashboard-filters">
      <div className="flex items-center gap-1.5">
        <Clock className="w-3.5 h-3.5 text-muted-foreground" />
        <span className="micro-label">Time</span>
        <Select value={timeRange} onValueChange={onTimeRangeChange}>
          <SelectTrigger
            className="h-7 w-36 px-2 text-[11px] font-medium tracking-tight bg-transparent border-border rounded-none"
            data-testid="dashboard-filter-time-trigger"
          >
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="rounded-none">
            {TIME_RANGES.map((r) => (
              <SelectItem
                key={r.value}
                value={r.value}
                className="text-[11px] tracking-tight"
                data-testid={`dashboard-filter-time-${r.value}`}
              >
                {r.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-1.5">
        <MapPin className="w-3.5 h-3.5 text-muted-foreground" />
        <span className="micro-label">Zone</span>
        <Select value={zoneId || "all"} onValueChange={(v) => onZoneChange(v === "all" ? null : v)}>
          <SelectTrigger
            className="h-7 w-44 px-2 text-[11px] font-medium tracking-tight bg-transparent border-border rounded-none"
            data-testid="dashboard-filter-zone-trigger"
          >
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="rounded-none">
            <SelectItem value="all" className="text-[11px] tracking-tight" data-testid="dashboard-filter-zone-all">
              All Zones
            </SelectItem>
            {zones.map((z) => (
              <SelectItem
                key={z.id}
                value={z.id}
                className="text-[11px] tracking-tight"
                data-testid={`dashboard-filter-zone-${z.id}`}
              >
                {z.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <button
        onClick={onRefresh}
        className="btn-tac !px-2 !py-1.5"
        data-testid="dashboard-refresh-btn"
        aria-label="Refresh dashboard"
      >
        <RefreshCw className={`w-3.5 h-3.5 ${refreshing ? "animate-spin" : ""}`} />
      </button>
    </div>
  );
};

export default DashboardFilters;
